import {Modal} from 'components/ui';
import {ReactNode, useState} from 'react';
import ReactDOM from 'react-dom';
import styles from './RootModal.module.scss';

interface RootModalProps {
  children: ReactNode;
  modalContent: ReactNode;
  modalTitle: string;
}

function RootModal({
  children,
  modalContent,
  modalTitle,
}: RootModalProps): JSX.Element {
  const [showModal, setShowModal] = useState(false);

  const rootElement = window.document.getElementById('root');

  return (
    <>
      <div role="button" onClick={() => setShowModal(!showModal)}>
        {children}
      </div>
      {rootElement &&
        !!modalContent &&
        ReactDOM.createPortal(
          <div className={styles.modal}>
            <Modal
              isOpen={showModal}
              onClose={() => setShowModal(!showModal)}
              clickOutsideToClose
              title={modalTitle}
            >
              {modalContent}
            </Modal>
          </div>,
          rootElement,
        )}
    </>
  );
}

export default RootModal;
